module.exports = __webpack_public_path__ + "img/collection-engagementRingsTensionRing.7623e64.webp";